/**
* 单任务在班级内的详情
*/
<template>
    <span>
        <a @click="openmodel()">详情</a>
        <a-modal :visible="visible" :width="1280" destroyOnClose title="任务详细情况" @ok="okmodel" @cancel="cancelmodel">
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="班级任务信息">
                    <a-descriptions title="班级信息">
                        <a-descriptions-item label="班级名">
                            {{ squadinfo.name }}
                        </a-descriptions-item>
                        <a-descriptions-item label="班级人数">
                            {{ squadinfo.actual }}
                        </a-descriptions-item>
                        <a-descriptions-item label="正常人数(除住校)">
                            {{ squadinfo.statistic }}
                        </a-descriptions-item>
                    </a-descriptions>


                    <a-descriptions title="任务信息">
                        <a-descriptions-item label="任务名">
                            {{ missioninfo.missionname }}
                        </a-descriptions-item>

                        <a-descriptions-item label="应参人数">
                            {{ missioninfo.squad_all_usermission }}
                        </a-descriptions-item>
                        <a-descriptions-item label="实参人数">
                            {{ missioninfo.squad_all_student_actual }}
                        </a-descriptions-item>

                        <a-descriptions-item label="应参人数(除住校与退出)">
                            {{ missioninfo.squad_student_arrive }}
                        </a-descriptions-item>
                        <a-descriptions-item label="实参人数(除住校与退出)">
                            {{ missioninfo.squad_student_actual }}
                        </a-descriptions-item>
                        <a-descriptions-item label="正确率">
                            {{ parseFloat(missioninfo.problems_isright / missioninfo.problems_correct).toFixed(2) }}
                        </a-descriptions-item>
                    </a-descriptions>
                </a-tab-pane>
                <a-tab-pane key="2" tab="题目信息" force-render>
                    <a-list item-layout="vertical" :data-source="questionList">
                        <a-list-item slot="renderItem" key="item.title" slot-scope="item">
                            <a-list-item-meta>
                                <div slot="title">
                                    <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                        v-if="item.typestr == 'ANSWER'">问答题
                                    </a-tag>
                                    <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                        v-if="item.typestr == 'PREVIEW'">预习题
                                    </a-tag>
                                    <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                        v-if="item.typestr == 'JUDGMENT'">判断题
                                    </a-tag>
                                    <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                        v-if="item.typestr == 'COMPLETION'">填空题
                                    </a-tag>
                                    <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                        v-if="item.typestr == 'VIDEO'">口述题
                                    </a-tag>
                                    <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                        v-if="item.typestr == 'SINGLE_CHOICE'">单选题
                                    </a-tag>
                                    <div v-html="item.title" />
                                </div>
                                <template slot="description">
                                    <a-row :gutter="16" v-if="item.typestr == 'SINGLE_CHOICE'">
                                        <a-col :span="6" v-for="option in item.options" :key="option.value">
                                            <div class="option">
                                                <label class="label">{{ option.keys }}:</label>

                                                <div class="span" v-html="option.value" />
                                            </div>
                                        </a-col>
                                    </a-row>
                                    <div>
                                        <span v-if="item.typestr == 'ANSWER' || item.typestr == 'VIDEO'">参考答案:</span>
                                        <span
                                            v-if="item.typestr == 'JUDGMENT' || item.typestr == 'COMPLETION' || item.typestr == 'SINGLE_CHOICE'">答案:</span>
                                        <span>{{ item.answer }}</span>
                                    </div>
                                </template>
                            </a-list-item-meta>
                            <div>
                                <a-rate :value="item.star"></a-rate>
                                <a-divider type="vertical" v-if="item.tag.length > 0"></a-divider>
                                <a-tag v-for="tag in item.tag" :key="tag" color="#2db7f5">{{ tag }}</a-tag>
                                <a-divider v-if="item.previewvideo != ''" type="vertical"></a-divider>
                                <a @click="goQuestioninfo(item.id)">题目分析</a>
                                <a-divider type="vertical" />
                                <template v-if="item.systag != 0">
                                    <a-tag color="#2db7f5">相似题</a-tag>
                                    <a-divider type="vertical" />
                                </template>

                                <or-preview v-if="item.previewvideo != ''" text="预习视频" :videoUrl="item.previewvideo" />
                                <or-preview v-if="item.analysisvideo != ''" text="解析视频" :videoUrl="item.analysisvideo" />
                                <squadquestion v-bind:itemdata="item" v-bind:squad_id="squad_id"
                                    v-bind:mission_id="mission_id"></squadquestion>
                            </div>
                        </a-list-item>
                    </a-list>
                </a-tab-pane>
            </a-tabs>


        <!-- <a-row :gutter="16" style="margin-left: 50px">
                <a-col :span="6">

                    <a-statistic title="班级人数" :value="itemdata.actual">
                        <template #suffix>
                            <a-icon type="like" />
                        </template>
                    </a-statistic>
                </a-col>
                <a-col :span="6">
                    <a-statistic title="应参" :value="itemdata.statistic" class="demo-class">
                      
                    </a-statistic>
                </a-col>

                <a-col :span="6">
                    <a-statistic title="不参" :value="itemdata.actual-itemdata.statistic" class="demo-class">
                    
                        </a-statistic>
                    </a-col>
                </a-row> -->


            <a-divider></a-divider>
            <div>
                <a-table :dataSource="tabledata" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                    @change="onPaginationChange" bordered>

                    <a-table-column key="user" title="姓名" data-index="user_name" />

                    <a-table-column key="student_mission_time" title="完成时间"
                        :sorter="(item1, item2) => item1.student_mission_time - item2.student_mission_time">
                        <template slot-scope="item">
                            {{ parseFloat(item.student_mission_time / 1000).toFixed(0) }}秒
                        </template>
                    </a-table-column>

                <a-table-column key="sum_score" title="分数" data-index="sum_score"
                    :sorter="(item1, item2) => item1.sum_score - item2.sum_score" />
                <!--  <a-table-column key="problems_correct" title="已批改题目数" data-index="problems_correct" :sorter="(item1, item2) => item1.problems_correct - item2.problems_correct"/>
                     <a-table-column key="sjccl" title="总参测率" :sorter="(item1, item2) => parseFloat(item1.squad_student_actual/item1.squad_student_cnt).toFixed(2) - parseFloat(item2.squad_student_actual/item2.squad_student_cnt).toFixed(2)">
                         <template slot-scope="item">
                             {{parseFloat(item.squad_student_actual/item.squad_student_cnt).toFixed(2)}}
                         </template>
                     </a-table-column>
                     <a-table-column key="sjccl2" title="正常参测率" :sorter="(item1, item2) => parseFloat(item1.squad_student_actual/item1.squad_student_arrive).toFixed(2) - parseFloat(item2.squad_student_actual/item2.squad_student_arrive).toFixed(2)">
                         <template slot-scope="item">
                                 {{parseFloat(item.squad_student_actual/item.squad_student_arrive).toFixed(2)}}
                             </template>
                         </a-table-column> -->

                    <a-table-column key="rwzql" title="正确率"
                        :sorter="(item1, item2) => parseFloat(item1.right_cnt / item1.problem_cnt).toFixed(2) - parseFloat(item2.right_cnt / item2.problem_cnt).toFixed(2)">
                        <template slot-scope="item">
                            <a-progress :percent="parseFloat((item.right_cnt / item.problem_cnt) * 100).toFixed(2)"
                                status="active" v-if="item.teacher_check != 0 && (item.right_cnt / item.problem_cnt) > 0" />
                            <a-progress :percent="0" status="active"
                                v-if="item.teacher_check != 0 && !(item.right_cnt / item.problem_cnt) > 0" />
                            <a-tag v-if="item.mission_status != 3" color="#f50">
                                未完成
                            </a-tag>
                        </template>

                    </a-table-column>
                    <!--    <a-table-column key="missiontypename" title="任务类型" data-index="missiontypename" /> -->
                </a-table>
                <div>总共{{ pageinfo.total }}条数据</div>
                <a-switch size="small" v-model="showcount" @change="getshowcount" />
            </div>
            <record title="任务详细情况" :chapter_name="itemdata.missionname" :class_id="squad_id" />
        </a-modal>
    </span>
</template>
<script>
//   import  squadusermodel from '@/views/orgpublish/squadusermodel.vue';
import squadquestion from '@/views/basic/squadquestioninfomodel.vue';
export default {
    components: { squadquestion },
    props: {
        itemdata: {},
        searchFrom: {},
        squad_id: undefined,
        mission_id: undefined
    },
    data() {
        return {
            data: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
            showcount: false,
            tabledata: [],
            loading: false,
            visible: false,
            squadinfo: [],
            missioninfo: [],
            usermission: [],
            questionList: [],
        };
    },
    mounted() {

    },
    computed: {

    },
    methods: {

        goQuestioninfo(questioninfoid) {
            let routeData = this.$router.resolve({
                path: '/questionfenxi/' + questioninfoid,
            });
            window.open(routeData.href, '_blank');

        },
        getshowcount() {
            if (this.showcount) {
                this.pageinfo.pageSize = 9999;
                this.pageinfo.current = 1;
                // this.showcount=true;
            }
            if (!this.showcount) {
                this.pageinfo.pageSize = 10;
                this.pageinfo.current = 1;
                // this.showcount=false;
            }
            this.getTableList();
        },
        getsquadinfo() {
            this.$axios
                .post("/api/OrgSquad/getinfo", {
                    data: {
                        id: this.squad_id
                    }
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.squadinfo = res.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })

        },

        getmissioninfo() {
            this.$axios
                .post("/api/CoreSquadMission/getCoreSquadMissioninfo", {
                    data: {
                        squad_id: this.squad_id,
                        mission_id: this.mission_id
                    }
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.missioninfo = res.data;
                        this.getproblemslist(this.missioninfo.testpaper_id);
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })

        },
        getproblemslist(testpaper_id) {
            this.$axios
                .post("/api/QuestionProblems/getproblemslist", {
                    data: { testpaper_id: testpaper_id }
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.questionList = res.data;
                        for (let i = 0; i < this.questionList.length; i++) {
                            if (this.questionList[i]["tag"] != "") {
                                this.questionList[i]["tag"] = this.questionList[i][
                                    "tag"
                                ].split(",");
                            }
                        }

                    }
                })
                .catch(err => {
                    console.error(err);
                });
            this.visible = true;
        },
        getTableList() {
            //  this.searchFrom.squad_id=this.itemdata.id;
            this.loading = true;
            this.$axios
                .post("/api/CoreUserMission/getsquaduserlist", {
                    data: {
                        squad_id: this.squad_id,
                        mission_id: this.mission_id
                    },
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                        this.tabledata = null;
                    } else {
                        this.tabledata = res.data.data;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },

        openmodel() {
            this.visible = true;
            this.getmissioninfo();
            this.getsquadinfo();
            this.getTableList();
        },
        okmodel() {
            this.visible = false;
        },
        cancelmodel() {
            this.visible = false;
        },

        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList();
        },


    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
